<template>
  <div class="page-content">
    <h1>KMS – Edit Video</h1>
    <p>Edit video ID: {{ $route.params.id }}</p>
  </div>
</template>

<script>
export default {
  name: "KmsVideoEdit",
};
</script>
